require('!style-loader!css-loader!video.js/dist/video-js.css');